var map = {
	"./0fd3416c.jpeg": "00e9",
	"./1827379-21b799be.png": "2ca7",
	"./2229558.png": "e220",
	"./3670089.png": "326b",
	"./3932086.png": "7ed0",
	"./484167-0f572cc8.png": "8f9a",
	"./597177-de35359a.png": "9627",
	"./68f64b9d.jpeg": "40eb",
	"./7699395.png": "88d4",
	"./8ad73f3c.jpeg": "89d8",
	"./I-BOS-1101-0.png": "b2a1",
	"./I-BOS-1118-0.png": "7763",
	"./I-BOS-1136-0.png": "4bc3",
	"./I-BOS-1301-0.png": "ea92",
	"./I-BOS-1302-0.png": "263e",
	"./RBSOVEN70LM2.png": "55e5",
	"./Smart-LED.webp": "aaab",
	"./anewdaylogo.png": "5d1e",
	"./banner-home1.webp": "1f75",
	"./email-icons-white-color-958812.jpg": "4788",
	"./img-brand-blackhole.webp": "167e",
	"./img-cate1.webp": "aebb",
	"./img-cate2.webp": "c2a9",
	"./img-cate3.webp": "a9ad",
	"./img-cate4.webp": "1d25",
	"./logo-anewday_1full_color.webp": "f2fd",
	"./qr1.png": "6746"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0142";